// extracted by mini-css-extract-plugin
export default {"link":"link_link__QqYbd","center":"link_center__ncjHO","block":"link_block__JbBbc","bold":"link_bold__X+WUy","white":"link_white__aQHWd","muted":"link_muted__0bMgj"};